import { ReactNode } from 'react'

export type SidebarGroupProps = {
  children?: ReactNode
}

export function SidebarGroup({ children }: SidebarGroupProps) {

  return (
    <div className="flex flex-col p-2.5 gap-1.5">
      { children }
    </div>
  )
}
